<template>
  <div class="row q-ma-xl">
    <div class="col">
      <div class="text-h4 q-mb-xl">Ping</div>
      Ping:
      <div>
        <pre>{{ pongFormatted }}</pre>
      </div>
      Token Ping:
      <div>
        <pre>{{ tokenPongFormatted }}</pre>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { ping, pingWithToken } from "@/apis/ping-service";

export default {
  name: "Ping",
  data() {
    return {
      pong: {},
      tokenPong: {},
    };
  },
  mounted() {
    ping().then(response => {
      this.pong = Object.assign({}, response);
    });
  },
  computed: {
    ...mapState(["idToken"]),
    pongFormatted() {
      return JSON.stringify(this.pong, null, 2);
    },
    tokenPongFormatted() {
      return JSON.stringify(this.tokenPong, null, 2);
    },
  },
  watch: {
    idToken: {
      handler() {
        pingWithToken(this.idToken).then(response => {
          this.tokenPong = Object.assign({}, response);
        });
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped></style>
